import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { SIDEBAR_WIDTH, TOPBAR_HEIGHT } from '../../theme';

export function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  // Reset scroll state on every navigation. MUI Drawers/Dialogs lock body scroll
  // (overflow:hidden + padding-right) while open; if one unmounts during a route
  // change its cleanup can race and leave the lock applied, making the next page
  // "stuck" / unable to scroll fully. Clearing any stray lock and resetting scroll
  // position here guarantees each page starts in a clean, scrollable state.
  useEffect(() => {
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
    window.scrollTo(0, 0);
  }, [pathname]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar */}
      <Sidebar mobileOpen={mobileOpen} onMobileClose={handleDrawerToggle} />

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: { sm: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        {/* Top bar */}
        <TopBar onMenuClick={handleDrawerToggle} showMenuButton />

        {/* Page content */}
        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            mt: `${TOPBAR_HEIGHT}px`,
            bgcolor: 'background.default',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
